// import dashboards from "./dashboards"
import policedashboard from "./policedashboard"
import pages from "./pages"
import userInterface from "./user-interface"

export default [
  policedashboard,
  pages,
  userInterface,
]